import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'formatIPs'})
export class FormatIPsPipe implements PipeTransform {
  transform(ips: string): string {
    return ips.split(',').map(function(item) {
        return item.trim();
      }).join(', ');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/format-ip-pipe.ts